import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { IAddressNote, IAddressNoteForm, IAddressNoteType } from '@/models';

import { http } from './http';
import { IGetParams, IListResponse, IPaginatedListResponse } from './types';

export const AddressNoteApi = {
  getAddressNotes: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IListResponse<IAddressNote>>> => {
    return http.get(`api/${ApiVersion.V1}/address-notes/address-notes/`, {
      params,
    });
  },
  getPaginatedAddressNotes: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IPaginatedListResponse<IAddressNote>>> => {
    return http.get(`api/${ApiVersion.V1}/address-notes/address-notes/list`, {
      params,
    });
  },
  getAddressNote: (id: string): Promise<AxiosResponse<IAddressNote>> => {
    return http.get(`api/${ApiVersion.V1}/address-notes/address-notes/${id}`);
  },
  getAddressNoteTypes: (): Promise<AxiosResponse<IAddressNoteType[]>> => {
    return http.get(`api/${ApiVersion.V1}/address-notes/address-note-types`);
  },
  createAddressNote: (
    data: IAddressNoteForm,
  ): Promise<AxiosResponse<IAddressNote>> => {
    return http.post(`api/${ApiVersion.V1}/address-notes/address-notes`, data);
  },
  updateAddressNote: (
    id: string,
    data: IAddressNoteForm,
  ): Promise<AxiosResponse<IAddressNote>> => {
    return http.patch(
      `api/${ApiVersion.V1}/address-notes/address-notes/${id}`,
      data,
    );
  },
  deleteAddressNote: (id: string): Promise<AxiosResponse<IAddressNote>> => {
    return http.delete(
      `api/${ApiVersion.V1}/address-notes/address-notes/${id}`,
    );
  },
};
